import { Navigate, Route } from 'react-router-dom';
import { PlantItemRenewalFees } from 'plantItemRenewal/pages/fees/plantItemRenewalFees';
import { PrivateRoute } from 'shared/components/privateRoute/PrivateRoute';
import { ProgressStepperLayout } from 'layouts/ProgressStepperLayout';
import { PlantItemRenewalConfirmation } from 'plantItemRenewal/pages/confirmation/PlantItemRenewalConfirmation';
import { PlantItemRenewalContactDetails } from 'plantItemRenewal/pages/contactDetails/PlantItemRenewalContactDetails';
import { PlantItemRenewalDeclaration } from 'plantItemRenewal/pages/declaration/PlantItemRenewalDeclaration';
import { PlantItemRenewalReviewItems } from 'plantItemRenewal/pages/reviewItems/PlantItemRenewalReviewItems';
import { PagePath } from 'shared/constants/pagePath';
import { PlantItemRenewalFind } from 'plantItemRenewal/pages/findRenewal/PlantItemRenewalFind';
import { stepperStatus } from 'shared/constants/constants';
import { PageLayout } from 'layouts/PageLayout';
import { AddInspectionCertificates } from 'plantItemRenewal/pages/inspectionCertificates/AddInspectionCertificates';
import { EditItem } from 'plantItemRenewal/pages/editItem/EditItem';

const React = require('react');

const PlantItemRenewalRoutes = (props) => {
  const initStepsList = [
    { content: 'Find your renewal', status: stepperStatus.todo },
    { content: 'Review items', status: stepperStatus.todo },
    { content: 'Contact details', status: stepperStatus.todo },
    { content: 'Declaration', status: stepperStatus.todo },
    { content: 'Payment', status: stepperStatus.todo },
  ];

  const rootPath = PagePath.plantItemRenewalFind;

  return (
    <>
      <Route path="/item-renewal" element={<Navigate replace to={rootPath} />} />

      <Route
        path={PagePath.plantItemRenewalFind}
        element={
          <PrivateRoute storeRedirect storeCurrentPath>
            <ProgressStepperLayout
              title="Find your renewal"
              label="Renew the registration of a plant item"
              stepsList={Object.assign([], initStepsList, [
                { content: 'Find your renewal', status: stepperStatus.current },
              ])}
            >
              <PlantItemRenewalFind />
            </ProgressStepperLayout>
          </PrivateRoute>
        }
      />
      <Route
        path={PagePath.plantItemRenewalReviewItems}
        element={
          <PrivateRoute storeCurrentPath storeRedirect>
            <ProgressStepperLayout
              title="Confirm items to renew"
              label="Renew the registration of a plant item"
              stepsList={Object.assign([], initStepsList, [
                { content: 'Find your renewal', status: stepperStatus.completed },
                { content: 'Review items', status: stepperStatus.current },
              ])}
            >
              <PlantItemRenewalReviewItems />
            </ProgressStepperLayout>
          </PrivateRoute>
        }
      />
      <Route
        path={PagePath.plantItemRenewalAddCertificates}
        element={
          <PrivateRoute storeCurrentPath storeRedirect>
            <PageLayout title="Add inspection certificate" label="Renew the registration of a plant item">
              <AddInspectionCertificates />
            </PageLayout>
          </PrivateRoute>
        }
      />
      <Route
        path={PagePath.plantItemRenewalEditItem}
        element={
          <PrivateRoute storeCurrentPath storeRedirect>
            <PageLayout title="Edit details for this item" label="Renew the registration of a plant item">
              <EditItem />
            </PageLayout>
          </PrivateRoute>
        }
      />
      <Route
        path={PagePath.plantItemRenewalContactDetails}
        element={
          <PrivateRoute storeCurrentPath storeRedirect>
            <ProgressStepperLayout
              title="Contact details"
              label="Renew the registration of a plant item"
              stepsList={Object.assign([], initStepsList, [
                { content: 'Find your renewal', status: stepperStatus.completed },
                { content: 'Review items', status: stepperStatus.completed },
                { content: 'Contact details', status: stepperStatus.current },
              ])}
            >
              <PlantItemRenewalContactDetails />
            </ProgressStepperLayout>
          </PrivateRoute>
        }
      />
      <Route
        path={PagePath.plantItemRenewalDeclaration}
        element={
          <PrivateRoute storeCurrentPath storeRedirect>
            <ProgressStepperLayout
              title="Declaration"
              label="Renew the registration of a plant item"
              stepsList={Object.assign([], initStepsList, [
                { content: 'Find your renewal', status: stepperStatus.completed },
                { content: 'Review items', status: stepperStatus.completed },
                { content: 'Contact details', status: stepperStatus.completed },
                { content: 'Declaration', status: stepperStatus.current },
              ])}
            >
              <PlantItemRenewalDeclaration />
            </ProgressStepperLayout>
          </PrivateRoute>
        }
      />
      <Route
        path={PagePath.plantItemRenewalFees}
        element={
          <PrivateRoute storeCurrentPath storeRedirect>
            <ProgressStepperLayout
              title="Make a payment"
              label="Renew the registration of a plant item"
              stepsList={Object.assign([], initStepsList, [
                { content: 'Find your renewal', status: stepperStatus.completed },
                { content: 'Review items', status: stepperStatus.completed },
                { content: 'Contact details', status: stepperStatus.completed },
                { content: 'Declaration', status: stepperStatus.completed },
                { content: 'Payment', status: stepperStatus.current },
              ])}
            >
              <PlantItemRenewalFees />
            </ProgressStepperLayout>
          </PrivateRoute>
        }
      />

      <Route
        path={PagePath.plantItemRenewalConfirmation}
        element={
          <PrivateRoute storeCurrentPath storeRedirect>
            <ProgressStepperLayout
              title="Confirmation"
              label="Renew the registration of a plant item"
              stepsList={Object.assign([], initStepsList, [
                { content: 'Find your renewal', status: stepperStatus.completed },
                { content: 'Review items', status: stepperStatus.completed },
                { content: 'Contact details', status: stepperStatus.completed },
                { content: 'Declaration', status: stepperStatus.completed },
                { content: 'Payment', status: stepperStatus.completed },
              ])}
            >
              <PlantItemRenewalConfirmation />
            </ProgressStepperLayout>
          </PrivateRoute>
        }
      />
    </>
  );
};

export default PlantItemRenewalRoutes;
